import { UploadedFile } from '@brands/Dashboard/MyProfile/Patient/utils/utilsFunctions';
import { InsuranceMedia } from '@brands/services/identity/types/UserProfile';

export interface InsuranceMediaContent {
  src: string;
  width: number;
  height: number;
  type: string;
  dataURL: string;
  name: string;
}

export type InsuranceForm = {
  member_id: string;
  group_number?: string;
  insurance_through: string;
  insurance_carrier_id?: number | null;
  insurance_first_name: string;
  insurance_date_of_birth: string;
  insurance_gender: string;
  insurance_last_name: string;
  insurance_address1: string;
  insurance_address2: string;
  insurance_zip_code1: string;
  insurance_state1: string;
  insurance_city1: string;
  insurance_phone_number: string;
  insurance_address?: string;
  insurance_city?: string;
  insurance_state?: string;
  insurance_zip_code?: string;
  front_of_card: UploadedFile[];
  back_of_card: UploadedFile[];
  other_insurance_name?: string;
  secondary_group_number?: string;
  secondary_member_id: string;
  secondary_insurance_phone_number: string;
  secondary_insurance_through: string;
  secondary_insurance_carrier_id?: number | null;
  secondary_insurance_address?: string;
  secondary_insurance_city?: string;
  secondary_insurance_state?: string;
  secondary_insurance_zip_code?: string;
  secondary_insurance_first_name: string;
  secondary_insurance_date_of_birth: string;
  secondary_insurance_gender: string;
  secondary_insurance_last_name: string;
  secondary_insurance_address1: string;
  secondary_insurance_address2: string;
  secondary_insurance_zip_code1: string;
  secondary_insurance_state1: string;
  secondary_insurance_city1: string;
  secondary_front_of_card: UploadedFile[];
  secondary_back_of_card: UploadedFile[];

  media?: InsuranceMedia[];
  state_funded_coverage_status?: string;
  is_secondary?: boolean;
};

export const defaultInsuranceForm: InsuranceForm = {
  member_id: '',
  group_number: '',
  insurance_through: '',
  insurance_carrier_id: null,
  insurance_first_name: '',
  insurance_date_of_birth: '',
  insurance_gender: '',
  insurance_last_name: '',
  insurance_address1: '',
  insurance_address2: '',
  insurance_zip_code1: '',
  insurance_state1: '',
  insurance_city1: '',
  insurance_phone_number: '',
  insurance_address: '',
  insurance_city: '',
  insurance_state: '',
  insurance_zip_code: '',
  front_of_card: [],
  back_of_card: [],
  secondary_group_number: '',
  secondary_member_id: '',
  secondary_insurance_phone_number: '',
  secondary_insurance_through: '',
  secondary_insurance_carrier_id: null,
  secondary_insurance_address: '',
  secondary_insurance_city: '',
  secondary_insurance_state: '',
  secondary_insurance_zip_code: '',
  secondary_insurance_first_name: '',
  secondary_insurance_date_of_birth: '',
  secondary_insurance_gender: '',
  secondary_insurance_last_name: '',
  secondary_insurance_address1: '',
  secondary_insurance_address2: '',
  secondary_insurance_zip_code1: '',
  secondary_insurance_state1: '',
  secondary_insurance_city1: '',
  secondary_front_of_card: [],
  secondary_back_of_card: [],
  media: [],
  state_funded_coverage_status: '',
};

export type InsuranceFormResponse = {
  member_id: string;
  group_number: string;
  insurance_through: string;
  insurance_carrier_id?: number;
  first_name: string;
  date_of_birth: string;
  gender: string;
  last_name: string;
  address1: string;
  address2: string;
  zip_code: string;
  state: string;
  city: string;
  phone_number: string;
  insurance_address?: string;
  insurance_city?: string;
  insurance_state?: string;
  insurance_zip_code?: string;
  media: InsuranceMedia[];
};

export type InsuranceImages = {
  front_of_card: InsuranceMediaContent[];
  back_of_card: InsuranceMediaContent[];
  secondary_front_of_card: InsuranceMediaContent[];
  secondary_back_of_card: InsuranceMediaContent[];
};
